import moment from 'moment';
import { formValidation } from '../util/formValidation';

var mpRegexNoLeadingDecimal = new RegExp(formValidation.regex.mpRegexNoLeadingDecimal);
var mpRegexNoDecimal = new RegExp(formValidation.regex.mpRegexNoDecimal);
var phoneRegexNoDash = new RegExp(formValidation.regex.phoneRegexNoDash);

/**
 * Clones a form B object using JSON stringify
 * @param oldObj
 */
function clone(oldObj) {
    return JSON.parse(JSON.stringify(oldObj))
}

//public api
export const formbScrubber = {
    /**
     * Main entry method to scrub a form b
     * calls cleanupMilePosts, addDayOfWeek, cleanupPhonenumber in order
     * @param _formb
     * @returns {*}
     */
    scrub: function (_formb) {
        var formb = this.cleanupMilePosts(_formb);

        formb = this.addDayOfWeek(formb);

        formb = this.cleanupPhonenumber(formb);
        return this.sortTrackNames(formb);
    },


    /**
     * Appends ".0" to any milepost that does not have a decimal already.
     * Puts the smaller mp in the From MP field
     * Returns a copy of the form b with the changed values
     * @param _formb
     * @returns {*}
     */
    cleanupMilePosts: function (_formb) {
        //append ".0" to valid MPs
        var formb = clone(_formb);

        if (mpRegexNoDecimal.test(_formb.workStartMp)) {
            formb.workStartMp = _formb.workStartMp + '.0';
        }
        if (mpRegexNoDecimal.test(_formb.workEndMp)) {
            formb.workEndMp = _formb.workEndMp + '.0';
        }
        if (mpRegexNoDecimal.test(_formb.shortFlagOneMp)) {
            formb.shortFlagOneMp = _formb.shortFlagOneMp + '.0';
        }
        if (mpRegexNoDecimal.test(_formb.shortFlagTwoMp)) {
            formb.shortFlagTwoMp = _formb.shortFlagTwoMp + '.0';
        }

        if (mpRegexNoLeadingDecimal.test(_formb.workStartMp)) {
            formb.workStartMp = '0' + _formb.workStartMp;
        }
        if (mpRegexNoLeadingDecimal.test(_formb.workEndMp)) {
            formb.workEndMp = '0' + _formb.workEndMp;
        }
        if (mpRegexNoLeadingDecimal.test(_formb.shortFlagOneMp)) {
            formb.shortFlagOneMp = '0' + _formb.shortFlagOneMp;
        }
        if (mpRegexNoLeadingDecimal.test(_formb.shortFlagTwoMp)) {
            formb.shortFlagTwoMp = '0' + _formb.shortFlagTwoMp;
        }

        if (_formb.workStartMpSuffix) {
            formb.workStartMpSuffix = _formb.workStartMpSuffix.toUpperCase();
        }

        if (_formb.workEndMpSuffix) {
            formb.workEndMpSuffix = _formb.workEndMpSuffix.toUpperCase();
        }

        if (_formb.shortFlagOneMpSuffix) {
            formb.shortFlagOneMpSuffix = _formb.shortFlagOneMpSuffix.toUpperCase();
        }

        if (_formb.shortFlagTwoMpSuffix) {
            formb.shortFlagTwoMpSuffix = _formb.shortFlagTwoMpSuffix.toUpperCase();
        }


        ////always keep the smaller MP in the FROM MP field
        //if (formb.workEndMp < formb.workStartMp){
        //    var temp = formb.workStartMp;
        //    var tempSfx = formb.workStartMpSuffix;
        //
        //    formb.workStartMp = formb.workEndMp;
        //    formb.workStartMpSuffix = formb.workStartMpSuffix;
        //
        //    formb.workEndMp = temp;
        //    formb.workEndMpSuffix = tempSfx;
        //}

        return formb;
    },

    /**
     * Updates the day of week field on a form B
     * returns a copy of the form b with the new values
     * @param _formb
     * @returns {*}
     */
    addDayOfWeek: function (_formb) {
        //assign the dow to the _formb.dayOfWeek field
        var formb = clone(_formb);

        var startDateTime = moment(_formb.workStartDate + _formb.workStartTime, 'MMDDYYHHmm');
        var endDateTime = moment(_formb.workEndDate + _formb.workEndTime, 'MMDDYYHHmm');

        if (startDateTime.isValid() && endDateTime.isValid()) {
            formb.workEndDay = endDateTime.format('ddd');
            formb.workStartDay = startDateTime.format('ddd');
        }
        return formb;
    },

    /**
     * inserts hyphens into the phone number
     * returns a copy of the form b with the new values
     * @param _formb
     * @returns {*}
     */
    cleanupPhonenumber: function (_formb) {
        //add hyphens to the phonenumber
        var formb = clone(_formb);


        if (phoneRegexNoDash.test(_formb.phoneNumber)) {
            formb.phoneNumber = _formb.phoneNumber.slice(0, 3) + '-' + _formb.phoneNumber.slice(3, 6) + '-' + _formb.phoneNumber.slice(6);
        }

        return formb;
    },


    sortTrackNames: function (_formb) {
        var formb = clone(_formb);

        formb.tracks = orderTracks(formb.tracks);
        return formb;
    },

    orderTracks: function (tracks) {
        return orderTracks(tracks)
    }


};

function trackCompare(t1, t2) {
    if (t1.name < t2.name) {//tr1 is before tr2
        return -1;
    }
    if (t1.name > t2.name) {//a is greater than b by the ordering criterion) {
        return 1;
    }
    // a must be equal to b
    return 0;
}

function orderTracks(tracks) {
    var mainTracks = [];
    var nonMainTracks = [];

    for (var i = 0; i < tracks.length; i++) {
        if (tracks[i].name.toLowerCase().indexOf("main") >= 0) {
            mainTracks.push(tracks[i]);
        }
        else {
            nonMainTracks.push(tracks[i]);
        }
    }

    mainTracks.sort(trackCompare);
    nonMainTracks.sort(trackCompare);

    return mainTracks.concat(nonMainTracks);
}

